export default class SelectOption {
  constructor(text, value) {
    this.text = text;
    this.value = value;
  }
}